import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';

import { Modal, message, Radio, Checkbox, Input } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const headers = utils.columns(
    [
        {type: 'selection'},
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'schoolName',
            label: '学校',
            width: 150
        },
        {
            key: 'openCourseNum',
            label: '应开科门数',
            width: 120
        },
        {
            key: 'actualOpenCourseNum',
            label: '实际开课门数',
            width: 125
        },
        {
            key:'serviceDepartment', 
            label: '信息技术服务部门名称',
            width: 180
        },
        {
            key: 'isBuildOnlinePlatform',
            label: '是否搭建专门线上教学平台',
            width: 205,
            render: (value) => {
                if(value) {
                    return '是'
                }
                return '否'
            }
        },
        {
            key:'onlinePlatformName', 
            label: '教学平台名称',
            width: 125,
            render: (value, column) => {
                if(column.isBuildOnlinePlatform) {
                    return value
                }
                return ''
            }
        },
        {
            key: 'resource1',
            label:  '国家课程资源',
            width: 125
        },
        {
            key: 'resource2',
            label:  '外校教学资源',
            width: 125
        },
        {
            key: 'resource3',
            label:  '本校教学资源',
            width: 125
        },
        {
            key: 'resource4',
            label:  '网上教学资源',
            width: 125
        },
        {
            key: 'resource5',
            label:  '国外教学资源',
            width: 125
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/ciqa/view/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
    // return new Promise(() => {
    //     let data = []
    //     return Object.assign({
    //         result: data.dataList || [],
    //             selects: (data.dataList || []).map(d => ({
    //                 value: d.id,
    //                 checked: false,
    //             })),
    //             checked: false,
    //             total: data.total,
    //             pageIndex: data.pageNum,
    //             pageSize: data.pageSize,
    //             notify: (data || []).length ? '' : '暂无数据...'
    //     })
    // })
}

export default {
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    querySearch,
}